  import { Layout } from "Layout";
  import React, { lazy } from "react";
  import { Navigate, Route, Routes } from "react-router-dom";
  import checkAccess from "utils/checkAccess";
  import Dialer from "../dialer/Dialer";
  import EventCheckInListing from "pages/DataManagement/EventListing/EventCheckInListing";

  //Pages
  const AdminDashbord = lazy(() => import("pages/Dashboard"));
  const RolesAdd = lazy(() => import("pages/MembersAndRoles/Roles/RolesAdd"));
  const RolesEdit = lazy(() => import("pages/MembersAndRoles/Roles/RolesEdit"));

  const TeamMembers = lazy(() => import("pages/MembersAndRoles/TeamMembers"));
  const AddTeamMember = lazy(
    () => import("pages/MembersAndRoles/TeamMembers/AddTeamMember"),
  );
  const EditTeamMember = lazy(
    () => import("pages/MembersAndRoles/TeamMembers/EditTeamMember"),
  );
  const Language = lazy(() => import("pages/DataManagement/Language"));
  const AdminProfile = lazy(() => import("pages/AdminProfile/Profile"));
  const AdminChangePass = lazy(() => import("pages/AdminProfile/ChangePass"));
  const RejectReason = lazy(() => import("pages/DataManagement/RejectReason"));
  const BlockReason = lazy(() => import("pages/DataManagement/BlockReason"));
  const CancelPlanReason = lazy(
    () => import("pages/DataManagement/CancelPlanReason"),
  );

  const Country = lazy(() => import("pages/DataManagement/Country"));

  const TermsAndConditionsPage = lazy(() => import("pages/TermsAndConditions"));
  const PrivacyPolicyPage = lazy(() => import("pages/PrivacyPolicy"));
  const DataDeletionPage = lazy(() => import("pages/DataDeletion"));

  const TermAndCondition = lazy(() => import("pages/CMS/TermAndCondition"));
  const PrivacyPolicy = lazy(() => import("pages/CMS/PrivacyPolicy"));
  const AdminSettings = lazy(() => import("pages/Settings"));
  const Permission = lazy(() => import("pages/MembersAndRoles/Permission"));
  const AddPermission = lazy(
    () => import("pages/MembersAndRoles/Permission/AddPermission"),
  );
  const Roles = lazy(() => import("pages/MembersAndRoles/Roles"));
  const ForgetPassword = lazy(() => import("pages/ForgetPassword"));
  const Error404 = lazy(() => import("pages/ErrorPages/Error404"));
  const Unauthorized = lazy(() => import("pages/ErrorPages/Unauthorized"));

  const ResetPassSuccessfully = lazy(() => import("pages/ResetPassSuccessfully"));
  const ResetPasswordAdmin = lazy(() => import("pages/ResetPasswordAdmin"));
  const AdminLogin = lazy(() => import("pages/Login/Login"));
  const UserPage = lazy(() => import("pages/Users"));
  const UserDetail = lazy(() => import("pages/Users/UserDetails"));
  const Tags = lazy(() => import("pages/DataManagement/Tags"));
  const Badge = lazy(() => import("pages/DataManagement/Badge"));
  const EventListing = lazy(() => import("pages/DataManagement/EventListing"));
  const EventDetail = lazy(() => import("pages/DataManagement/EventDetail"));

  const MessageTemplate = lazy(
    () => import("pages/DataManagement/MessageTemplate"),
  );
  const FollowUpTemplate = lazy(
    () => import("pages/DataManagement/FollowUpTemplate"),
  );
  const basePath = "";
  const generatePath = (slug) => {
    return `${basePath}/${slug}`;
  };

  export const adminRoutes = [
    {
      path: generatePath("dashboard"),
      element: <AdminDashbord />,
      title: "Dashboard",
    },
    {
      path: generatePath("error-404"),
      element: <Error404 />,
    },
    {
      path: generatePath("settings"),
      element: <AdminSettings />,
      title: "Settings",
    },
    {
      path: generatePath("terms"),
      element: <TermAndCondition />,
      title: "Terms And Conditions",
    },
    {
      path: generatePath("privacy"),
      element: <PrivacyPolicy />,
      title: "Privacy Policy",
    },
    {
      path: generatePath("/public-profile/profile"),
      element: <AdminProfile />,
      title: "My Profile",
    },
    {
      path: generatePath("/public-profile/change-password"),
      element: <AdminChangePass />,
      title: "Change Password",
    },
    {
      path: generatePath("/access-management/permission"),
      element: <Permission />,
      title: "Permissions",
      id: "permission",
    },
    {
      path: generatePath("/access-management/permission/addEdit-permission"),
      element: <AddPermission />,
      title: "Add Permission",
      action: "create",
      id: "permission",
    },
    {
      path: generatePath("/access-management/roles"),
      element: <Roles />,
      title: "Roles",
      id: "roles",
    },
    {
      title: "Team Members",
      path: generatePath("/access-management/team-members"),
      element: <TeamMembers />,
      id: "team_member",
    },
    {
      path: generatePath("/access-management/team-members/add-team-members"),
      element: <AddTeamMember />,
      title: "Add Team Member",
      action: "create",
      id: "team_member",
    },
    {
      path: generatePath("/access-management/team-members/edit-team-members"),
      element: <EditTeamMember />,
      title: "Edit Team Member",
      action: "update",
      id: "team_member",
    },
    {
      title: "Language",
      path: generatePath("/data-management/language"),
      element: <Language />,
      id: "language",
    },
    {
      title: "Message Templates",
      path: generatePath("/data-management/message-template"),
      element: <MessageTemplate />,
      id: "messagetemplate",
    },
    {
      title: "Follow Up Templates",
      path: generatePath("/data-management/followUp-template"),
      element: <FollowUpTemplate />,
      id: "followuptemplate",
    },
    {
      title: "Tags",
      path: generatePath("/data-management/tags"),
      element: <Tags />,
      id: "tags",
    },
    {
      title: "Badge",
      path: generatePath("/data-management/badge"),
      element: <Badge />,
      id: "badge",
    },
    {
      title: "Event Listing",
      path: generatePath("/data-management/event-listing"),
      element: <EventListing />,
      id: "eventlisting",
    },
    {
      title: "Add Role",
      path: generatePath("/access-management/roles/add"),
      element: <RolesAdd />,
      action: "create",
      id: "roles",
    },
    {
      title: "Edit Role",
      path: generatePath("/access-management/roles/edit/:id"),
      element: <RolesEdit />,
      action: "update",
      id: "roles",
    },
    {
      title: "Delete Account Reasons",
      path: generatePath("/data-management/reject-reason"),
      element: <RejectReason />,
      id: "reject_reason",
    },
    {
      title: "Cancel Plan Reasons",
      path: generatePath("/data-management/cancelPlan-reason"),
      element: <CancelPlanReason />,
      id: "cancelPlan-reason",
    },
    {
      title: "Block Account Reasons",
      path: generatePath("/data-management/block-reason"),
      element: <BlockReason />,
      id: "block_reason",
    },
    {
      title: "Countries",
      path: generatePath("/data-management/country"),
      element: <Country />,
      id: "country",
    },
    {
      title: "Users",
      path: generatePath("/user"),
      element: <UserPage />,
      id: "user",
    },
    {
      title: "User Detail",
      path: generatePath("/user/details/:id"),
      element: <UserDetail />,
      id: "user_detail",
    },
    {
      title: "Event Detail",
      path: generatePath("/data-management/event-listing/:id"),
      element: <EventDetail />,
      id: "event_detail",
    },

    {
  title: "Event Check In",
  path: generatePath("/data-management/event-listing/checkin/:id"),
  element: <EventCheckInListing type="event" />,
  id: "eventlisting",
},
// user-wise: Dashboard / Users / User Check In
{
  title: "User Check In",
  path: generatePath("/user/checkin/:id"),
  element: <EventCheckInListing type="user" />,
  id: "user",
},
  ];

  const adminAuthRoutes = [
    {
      path: generatePath("forget-password"),
      element: <ForgetPassword />,
    },
    {
      path: generatePath("resetpassword/successfully"),
      element: <ResetPassSuccessfully />,
    },
    {
      path: generatePath("resetAdminPassword/:id"),
      element: <ResetPasswordAdmin />,
    },
    {
      path: generatePath("/"),
      element: <AdminLogin />,
    },
    {
      path: generatePath("/dialer"),
      element: <Dialer />,
    },
  ];

  const publicRoutes = [
    {
      path: generatePath("/terms-condition-page"),
      element: <TermsAndConditionsPage />,
    },
    {
      path: generatePath("/privacy-policy-page"),
      element: <PrivacyPolicyPage />,
    },
    {
      path: generatePath("/data-deletion-page"),
      element: <DataDeletionPage />,
    },
  ];

  const AdminNavigation = () => {
    const user = JSON.parse(localStorage.getItem("coupleAi-admin"));

    return (
      <Routes>
        {/* if user is logged in redirect to dashboard */}
        {publicRoutes.map((route, index) => (
          <Route
            key={`${route.path}${index}`}
            path={route.path}
            element={route.element}
          />
        ))}
        <Route
          path=""
          element={!user ? <AdminLogin /> : <Navigate to="dashboard" />}
        />
        {/* if user is not present show unauthorized ui */}
        <Route element={!user ? <Navigate to="/" /> : <Layout />}>
          {adminRoutes.map((route, index) => {
            return (
              <Route
                key={`${route.path}${index}`}
                path={route.path}
                element={
                  route?.id ? (
                    checkAccess(`${route?.action ?? "read"}_${route.id}`) ? (
                      route.element
                    ) : (
                      <Navigate to={"/unauthorized"} replace={true} />
                    )
                  ) : (
                    route.element
                  )
                }
              />
            );
          })}
        </Route>
        {adminAuthRoutes.map((route, index) => {
          return (
            <Route
              key={`${route.path}${index}`}
              path={route.path}
              element={route.element}
            />
          );
        })}
        <Route
          path="/unauthorized"
          element={!user ? <Navigate to="/" /> : <Unauthorized />}
        />
        <Route path="*" element={!user ? <Navigate to="/" /> : <Error404 />} />
      </Routes>
    );
  };

  export default AdminNavigation;
